import { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "sonner";
import { AppProvider, useSite } from "./lib/store";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { CartDrawer } from "./components/CartDrawer";
import { CookieBar } from "./components/CookieBar";
import { BackToTop } from "./components/BackToTop";
import { Loader } from "./components/Loader";
import Home from "./pages/Home";
import Shop, { Favorites } from "./pages/Shop";
import Product from "./pages/Product";
import Checkout from "./pages/Checkout";
import { OrderPage, PaymentCancel, PaymentComgate, PaymentSuccess } from "./pages/Orders";
import AuthPage, { AuthCallback, ForgotPassword, ResetPassword } from "./pages/Auth";
import Account from "./pages/Account";
import ContentPage, { Contact } from "./pages/Content";
import AdminApp from "./admin/AdminApp";
import NotFound from "./pages/NotFound";
import GiftVouchers from "./pages/GiftVouchers";
import Unsubscribe from "./pages/Unsubscribe";

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const Shell = () => {
  const { site } = useSite();
  const [minDone, setMinDone] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setMinDone(true), 1700);
    document.getElementById("boot-loader")?.remove();
    return () => clearTimeout(t);
  }, []);
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  if (location.pathname.startsWith("/admin")) return <AdminApp />;
  return (
    <>
      <AnimatePresence>{(!site || !minDone) && <Loader key="loader" />}</AnimatePresence>
      <ScrollTop />
      <Header />
      <main className="min-h-[60vh]">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/eshop" element={<Shop />} />
          <Route path="/kategorie/:slug" element={<Shop />} />
          <Route path="/produkt/:slug" element={<Product />} />
          <Route path="/oblibene" element={<Favorites />} />
          <Route path="/darkove-poukazy" element={<GiftVouchers />} />
          <Route path="/odhlasit-odber" element={<Unsubscribe />} />
          <Route path="/pokladna" element={<Checkout />} />
          <Route path="/objednavka/:id" element={<OrderPage />} />
          <Route path="/platba/uspech" element={<PaymentSuccess />} />
          <Route path="/platba/comgate" element={<PaymentComgate />} />
          <Route path="/platba/zruseno" element={<PaymentCancel />} />
          <Route path="/prihlaseni" element={<AuthPage mode="login" />} />
          <Route path="/registrace" element={<AuthPage mode="register" />} />
          <Route path="/zapomenute-heslo" element={<ForgotPassword />} />
          <Route path="/reset-hesla" element={<ResetPassword />} />
          <Route path="/ucet" element={<Account />} />
          <Route path="/o-nas" element={<ContentPage page="about" />} />
          <Route path="/kontakt" element={<Contact />} />
          <Route path="/obchodni-podminky" element={<ContentPage page="terms" />} />
          <Route path="/gdpr" element={<ContentPage page="gdpr" />} />
          <Route path="/doprava-a-platba" element={<ContentPage page="payment" />} />
          <Route path="/reklamace" element={<ContentPage page="complaints" />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <CartDrawer />
      <CookieBar />
      <BackToTop />
    </>
  );
};

export default function App() {
  return (
    <BrowserRouter>
      <AppProvider>
        <Shell />
        <Toaster position="top-center" richColors toastOptions={{ style: { borderRadius: 999, fontFamily: "Outfit" } }} />
      </AppProvider>
    </BrowserRouter>
  );
}
